import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Tooltip } from "react-tooltip";
import { getTemplateDetail, updateTemplateDetail } from "../../../../utils/numberCounterApi";
import '../../../../assets/css/loader.css'; 

//Import Widgets
import WhiteThemeTemplateWidget from "../../../../components/Apps/NumberCounter/Template/WhiteThemeTemplateWidget";
import BlackThemeTemplateWidget from "../../../../components/Apps/NumberCounter/Template/BlackThemeTemplateWidget";
import ColoredNumbersTemplateWidget from "../../../../components/Apps/NumberCounter/Template/ColoredNumbersTemplateWidget";
import ColoredIconsTemplateWidget from "../../../../components/Apps/NumberCounter/Template/ColoredIconsTemplateWidget"; 
import MulticolorCountersTemplateWidget from "../../../../components/Apps/NumberCounter/Template/MulticolorCountersTemplateWidget";
import SingleCounterTemplateWidget from "../../../../components/Apps/NumberCounter/Template/SingleCounterTemplateWidget";

//Import Tabs
import ContentTab from "../../../../components/Apps/NumberCounter/ContentTab";
import LayoutTab from "../../../../components/Apps/NumberCounter/LayoutTab";
import StyleTab from "../../../../components/Apps/NumberCounter/StyleTab";
import SettingTab from "../../../../components/Apps/NumberCounter/SettingTab";

export default function EditNumberCounter() {
    const navigate = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(false); 
    const [activeSection, setActiveSection] = useState("Content");
    const [activeTemplateSection, setActiveTemplateSection] = useState("");
    const [selectedLayout, setSelectedLayout] = useState("");
    const [selectedTemplateImage, setSelectedTemplateImage] = useState("");
    const [renameWidgetNameModel, setRenameWidgetNameModel] = useState(false);
    const [widgetName, setWidgetName] = useState("Untitled Number Counter");
    const [newWidgetName, setNewWidgetName] = useState("");
    const { uuid } = useParams();
    const [isTemplateId, setIsTemplateId] = useState(null);  
    const [refreshWidgetList, setRefreshWidgetList] = useState(false);

    const [numberCounterTabData, setNumberCounterTabData] = useState({
        is_website_frontend: "",  
        widget_title: "",     
        number_of_columns: 3,     
        space_between_counters: "30px",   
        tablet_number_of_columns: 2,     
        tablet_space_between_counters: "20px",
        phone_number_of_columns: 2,     
        phone_space_between_counters: "20px",  
        width: "350",  
        position_alignment: "center",  
        background_color: "",     
        widget_title_color: "",     
        widget_title_size: "25px",     
        counter_background_color: "",     
        number_color: "",     
        caption_color: "",     
        icon_background_color: "",  
        font_type: "Default",       
        number_size: "38px",       
        caption_size: "18px",       
        icon_font_size: "60px", 
        is_enable_mobile_setting: 1, 
        tablet_number_size: "18px",       
        tablet_caption_size: "18px",       
        tablet_icon_font_size: "20px", 
        phone_number_size: "18px",       
        phone_caption_size: "18px",       
        phone_icon_font_size: "20px",  
        animation_speed: "1 Sec",       
        animation_type: "Ease Out",    
        is_enable_number_formatting: 1,   
        language_type: "English",   
        custom_css: "",   
        custom_js: "",   
    });

    // Open Widget Name Popup
    const openRenameWidgetNamePopup = () => {
        setNewWidgetName(widgetName);
        setRenameWidgetNameModel(true);
        document.body.classList.add("popup-open");
    };

    // Close Widget Name Popup
    const closeRenameWidgetNamePopup = () => {
        setRenameWidgetNameModel(false);
        document.body.classList.remove("popup-open");
    };

    // Save Widget Name Popup
    const saveWidgetName = () => {
        if (newWidgetName.trim() !== "") {
            setWidgetName(newWidgetName); 
        }
        closeRenameWidgetNamePopup();
    };

    // Function to update values dynamically
    const updateNumberCounterTabData = (key, value) => {
        setNumberCounterTabData((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    const menuItems = [
        { key: "Content", icon: "content.png", label: "Content" },
        { key: "Layout", icon: "layout.png", label: "Layout" },
        { key: "Style", icon: "style.png", label: "Style" },
        { key: "Settings", icon: "setting.png", label: "Settings" },
    ];

    // Fetching Tempate data
    useEffect(() => {
        const fetchData = async () => {
            try {
                const templateResult = await getTemplateDetail(uuid);

                //check if result is exist
                if (templateResult.data) {
                    setIsTemplateId(uuid);
                    setWidgetName(templateResult.data.name);
                    setActiveTemplateSection(templateResult.data.template_name);
                    setSelectedLayout(templateResult.data.layout_type);
                    setSelectedTemplateImage(templateResult.data.template_image);
                    // Convert settings array to object
                    const settingsObject = templateResult.data.settings.reduce((acc, setting) => {
                        acc[setting.setting_key] = setting.setting_value;
                        return acc;
                    }, {});

                    setNumberCounterTabData(settingsObject); 
                }
            } catch (error) {
                //console.error("Error fetching data:", error);
            }
        };
        
        fetchData();
    }, [uuid,setNumberCounterTabData]);
  
    //Update Form data
    const updateForm = async (e) => {
        e.preventDefault();

        setIsSubmitting(true);
        try {
            const extractedImageName = selectedTemplateImage.split('/').pop();

            // Convert settings object back into an array of key-value pairs
            const settingsArray = Object.entries(numberCounterTabData).map(([key, value]) => ({
                setting_key: key,
                setting_value: value,
            }));

            // Collect data from refs
            const payload = {
                template_id: isTemplateId,
                name: widgetName,
                template_name: activeTemplateSection,
                template_image: extractedImageName,
                layout_name: selectedLayout,
                layout_type: selectedLayout,
                settings: settingsArray,
            };
            
            //Api Call
            let api_response = await updateTemplateDetail(payload);

            //Check Responce
            if (api_response.status === true) {
                toast.success(api_response.message);
                // Redirect after 2 seconds
                setTimeout(() => {
                    navigate('/customer/apps/number-counter');
                }, 2000); 
            } else {
                toast.error(api_response.message);
            }
        } catch (error) {
            toast.error('Oops Something Wrong. Please Try Again!' + error.message);
        } finally {
            setIsSubmitting(false);
        }
    };

  return (
    <>
        <div className="create-goole-reviews-all">
            <div className="overlay-side-baar">
                <div className="side-baar-inner-one">
                    <ul>
                        {menuItems.map((item) => (
                            <li key={item.key}>
                                <button
                                    className={activeSection === item.key ? "active" : ""}
                                    onClick={() => setActiveSection(item.key)}
                                >
                                    <img
                                        src={`${process.env.PUBLIC_URL}/number-counter/icons/${item.icon}`}
                                        alt={`${item.key} icon`}
                                    />
                                    <span>{item.label}</span>
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="side-baar-inner-tow">
                    {/* Conditional Rendering for Sections */}
                    {activeSection === "Content" && (
                        <ContentTab updateNumberCounterTabData={updateNumberCounterTabData} numberCounterTabData={numberCounterTabData} setRefreshWidgetList={setRefreshWidgetList}/>
                    )}
                    {activeSection === "Layout" && (
                        <LayoutTab updateNumberCounterTabData={updateNumberCounterTabData} numberCounterTabData={numberCounterTabData} />
                    )}
                    {activeSection === "Style" && (
                        <StyleTab updateNumberCounterTabData={updateNumberCounterTabData} numberCounterTabData={numberCounterTabData} />
                    )}
                    {activeSection === "Settings" && (
                        <SettingTab updateNumberCounterTabData={updateNumberCounterTabData} numberCounterTabData={numberCounterTabData} />
                    )}
                </div>
            </div>
            <div className="create-goole-reviews-right">
                <div className="content-wrapper count-add-class">
                    <div className="source-header-row">
                        <h2><Link to="/customer/apps/number-counter"><i className="fa fa-angle-left" aria-hidden="true"></i> Back</Link> </h2>
                        <div className="untitled-widget-name">
                            <button onClick={openRenameWidgetNamePopup} data-tooltip-id="rename-tooltip"><img src={`${process.env.PUBLIC_URL}/number-counter/number-counter.svg`} alt="number-counter"/>{ widgetName }</button>
                            <Tooltip id="rename-tooltip" place="top" content="Rename Widget" />
                        </div>
                        <div className='submit-google-review'>
                          <button type="button" onClick={updateForm} className={`form-button ${isSubmitting ? 'disabled' : ''}`} disabled={isSubmitting}>Publish</button>
                          <Link to="/customer/apps/number-counter/pricing/single" className="view-plan">View Plans</Link>
                          <Link to="/customer/apps/number-counter" className="close-button">Close</Link></div>
                    </div>
                    <div className="source-title-row">Number Counter <i className="fa fa-angle-right" aria-hidden="true"></i> <strong>Connect</strong></div>

                    {/*Check template type*/}
                    {activeTemplateSection === "White_Theme_Temp" && (
                      <WhiteThemeTemplateWidget isTemplateId={isTemplateId} numberCounterTabData={numberCounterTabData} refreshWidgetList={refreshWidgetList} />
                    )}

                    {activeTemplateSection === "Black_Theme_Temp" && (
                      <BlackThemeTemplateWidget isTemplateId={isTemplateId} numberCounterTabData={numberCounterTabData} refreshWidgetList={refreshWidgetList} />
                    )}

                    {activeTemplateSection === "Colored_Numbers_Temp" && (
                      <ColoredNumbersTemplateWidget isTemplateId={isTemplateId} numberCounterTabData={numberCounterTabData} refreshWidgetList={refreshWidgetList} />
                    )}

                    {activeTemplateSection === "Colored_Icons_Temp" && (
                      <ColoredIconsTemplateWidget isTemplateId={isTemplateId} numberCounterTabData={numberCounterTabData} refreshWidgetList={refreshWidgetList} />
                    )}

                    {activeTemplateSection === "Multicolor_Counters_Temp" && (
                      <MulticolorCountersTemplateWidget isTemplateId={isTemplateId} numberCounterTabData={numberCounterTabData} refreshWidgetList={refreshWidgetList} />
                    )}

                    {activeTemplateSection === "Single_Counter_Temp" && (
                      <SingleCounterTemplateWidget isTemplateId={isTemplateId} numberCounterTabData={numberCounterTabData} refreshWidgetList={refreshWidgetList} />
                    )}
                </div>
            </div>
        </div>

        {/* Rename Popup */}
        {renameWidgetNameModel && (
            <div className="fixed top-50 left-50 w-full h-full bg-opacity-50 flex justify-center items-center popup-main rounded overflow-hidden widget-rename-model">
                <div className="bg-white p-3 rounded-lg shadow-lg">
                    <h3 className="text-lg font-semibold">Rename Widget</h3>
                    <label>Widget Name</label>
                    <input
                        type="text"
                        className="border p-2 w-full mt-2"
                        value={newWidgetName}
                        onChange={(e) => setNewWidgetName(e.target.value)}
                    />
                    <div className="mt-3 flex justify-end">
                        <button className="px-3 py-1 bg-gray-200 rounded mr-2" onClick={closeRenameWidgetNamePopup}>
                            Cancel
                        </button>
                        <button type="button" className="px-3 py-1 bg-blue-500 text-white rounded" onClick={saveWidgetName}>
                            Save
                        </button>
                    </div>
                </div>
            </div>
        )}
    </>
  );
} 